module.exports = __webpack_public_path__ + "img/delete.6a37469b.svg";